var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.spaceName,"with-refresh":false,"crumbs":_vm.crumbs}},[_c('location-form',{attrs:{"space-id":_vm.spaceId,"location-id":_vm.locationId},on:{"input":_vm.setLocation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }